import { defineStore } from 'pinia'
import router from '@/router'
import $axios from '@/services/api-koperasi'
import type {
  GetSaving,
  LoginResponse,
  Profile,
  UpdateAccount,
  UpdateInformation,
  User,
} from './type'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token'),
    check: false,
    user: {} as User,
    profile: {} as Profile,
  }),
  getters: {
    isAuth: (state) =>
      state.token != 'null' &&
      state.token != null &&
      state.token != '' &&
      state.token != 'undefined',
  },
  actions: {
    login(formData: Record<string, unknown>) {
      return new Promise<LoginResponse>((resolve, reject) => {
        $axios
          .post('/login', formData)
          .then((res) => {
            localStorage.setItem('token', res.data.token)
            this.token = res.data.token
            resolve(res.data)
          })
          .catch((e) => {
            reject(e.response.data)
          })
      })
    },
    logout() {
      return new Promise<{ status: string }>((resolve) => {
        $axios.post('/logout').then((res) => {
          localStorage.setItem('token', 'null')
          this.token = null
          router.push({ name: 'login' })
          resolve(res.data)
        })
      })
    },
    userLogin() {
      return new Promise<User>((resolve, reject) => {
        $axios
          .get('/me')
          .then((res) => {
            this.user = res.data.data
            resolve(res.data.data)
          })
          .catch((error) => {
            reject(error.response)
            if (error.response.status == 403) {
              localStorage.setItem('token', 'null')
              this.token = null
              router.push({ name: 'login' })
            }
            if (error.response.status == 401) {
              localStorage.setItem('token', 'null')
              this.token = null
              router.push({ name: 'login' })
            }
          })
      })
    },
    getProfile() {
      return new Promise<GetSaving>((resolve, reject) => {
        $axios
          .get('/profile')
          .then((res) => {
            this.profile = res.data.data
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    updateAccount(formData: UpdateAccount) {
      return new Promise<{ status: string }>((resolve, reject) => {
        $axios
          .put('/update-account', formData)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => {
            reject(error.response?.data || error)
          })
      })
    },
    updateInformation(formData: UpdateInformation) {
      return new Promise<{ status: string }>((resolve, reject) => {
        let dataToSend: FormData | UpdateInformation
        const config: Record<string, unknown> = {}
        if (formData.image instanceof File) {
          const fd = new FormData()
          fd.append('name', formData.name)
          fd.append('phone_number', formData.phone_number)
          fd.append('gender', formData.gender)
          fd.append('religion', formData.religion)
          fd.append('address', formData.address)
          fd.append('image', formData.image)
          dataToSend = fd
          config.headers = { 'Content-Type': 'multipart/form-data' }
        } else {
          dataToSend = { ...formData, image: null }
        }
        $axios
          .post('/update-information', dataToSend, config)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => {
            reject(error.response?.data || error)
          })
      })
    },
  },
})
